import { Stack, Typography } from '@mui/material'
import { TwinInsightFull } from 'api/model'
import { COLORS } from 'app-constants'
import { useEffect, useState } from 'react'

const InsightPill = ({
  insight,
  isSelected,
  onClick,
}: {
  insight: TwinInsightFull
  isSelected: boolean
  onClick: (insight: TwinInsightFull) => void
}) => {
  return (
    <Stack
      borderRadius="40px"
      alignItems="center"
      gap="10px"
      p="6px 14px"
      width="fit-content"
      onClick={() => {
        onClick(insight)
      }}
      sx={{
        border: isSelected ? '1px solid #2467F4' : '1px solid #DDD',
        background: isSelected ? COLORS.JELLED_MID_BLUE_10_PERCENT : COLORS.PURE_WHITE,
        cursor: 'pointer',
      }}>
      <Typography
        variant="pXS"
        sx={{
          color: isSelected ? COLORS.JELLED_PRIMARY_BLUE : COLORS.GRAY_0,
        }}>
        {insight.category.name}
      </Typography>
    </Stack>
  )
}

export const InsightsCard = ({ insights }: { insights: TwinInsightFull[] }) => {
  const [selectedInsight, setSelectedInsight] = useState<TwinInsightFull | null>(null)

  useEffect(() => {
    if (!insights || insights.length === 0) {
      return
    }
    if (insights.length > 0 && !selectedInsight) {
      setSelectedInsight(insights[0])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onInsightClick = (insight: TwinInsightFull) => {
    setSelectedInsight(insight)
  }

  const filteredInsights = insights.filter((i) => i.summary || i.observations.length > 0)

  return (
    <Stack
      borderRadius="8px"
      p={2}
      gap="16px"
      sx={{
        backgroundColor: COLORS.PURE_WHITE,
      }}>
      {insights.length === 0 ? (
        <Typography variant="pS">No summary to show yet.</Typography>
      ) : (
        <>
          <Typography variant="h5">Summary</Typography>

          <Stack
            gap="4px"
            sx={{
              flexWrap: 'wrap',
              flexDirection: 'row',
            }}>
            {filteredInsights.map((insight) => {
              const isSelected = selectedInsight?.category === insight.category

              return (
                <InsightPill
                  key={insight.category.id}
                  insight={insight}
                  isSelected={isSelected}
                  onClick={onInsightClick}
                />
              )
            })}
          </Stack>

          <Typography
            variant="pS"
            sx={{
              whiteSpace: 'pre-line',
              color: COLORS.GRAY_1,
            }}>
            {selectedInsight?.summary}
          </Typography>

          {selectedInsight?.observations && selectedInsight?.observations.length > 0 && (
            <ul
              style={{
                marginLeft: '-24px',
                marginTop: 0,
              }}>
              {selectedInsight?.observations.map((observation, index) => {
                return (
                  <li key={index}>
                    <Typography
                      variant="pS"
                      sx={{
                        color: COLORS.GRAY_1,
                      }}>
                      {observation.content}
                    </Typography>
                  </li>
                )
              })}
            </ul>
          )}
        </>
      )}
    </Stack>
  )
}

export default InsightsCard
